import { useHistory } from "react-router-dom";

import { ModelSearch } from "shared/components";
import { Button } from "shared/components/bulma/button";

const ModelEditTile = () => {
    const history = useHistory();

    const handleClick = (model) => {
        history.push(`overstock/${model.SKU}/edit`);
    }

    return (
        <article className="tile is-child notification">
            <p className="title">Find a Model</p>
            <p className="subtitle">Search a model to inspect or edit it.</p>
            <div className="content">
                <div className="field has-addons">
                    <div className="control is-expanded" id='model-find'>
                        <ModelSearch key="model-find" onClick={handleClick} />
                    </div>
                    <div className="control">
                        <Button className="is-primary">Find</Button>
                    </div>
                </div>
            </div>
        </article>
    );
}

export { ModelEditTile };
